import { FileInput } from '@mantine/core';
import React from 'react';
import { useSelector } from 'react-redux';
import { URL_PREFIX } from '../../constants/stores';
import { IconUpload } from '@tabler/icons-react';
import { IconButton } from '@mui/material';

// Define prop types for the FileUpload component
interface FileUploadProps {
    uploadApi: string;
    id: string;
    trailer_no: string;
    setTrailers: React.Dispatch<React.SetStateAction<any[]>>;
    accept?: string;
    varient?: 'unstyled' | 'default' | 'filled';
    compact?: boolean;
}

const FileUpload: React.FC<FileUploadProps> = ({ id, uploadApi, accept, trailer_no, varient, setTrailers, compact }) => {
    const token = useSelector((state: any) => state.user.sessionId);

    const handleUploadFile = async (files: File[] | null) => {
        if (!files) return;
        // check if the file size is greater than 1MB (1048576 bytes) alert if it is
        const fileSizeLimit = 1048576; // 1MB
        const isFileSizeExceeded = files.some((file: File) => file.size > fileSizeLimit);
        if (isFileSizeExceeded) {
            alert("File size exceeds 1MB");
            return;
        }

        // Handle file upload logic here
        const formData = new FormData();
        Array.from(files)?.forEach((file: File) => {
            formData.append("files", file);
        });
        formData.append('id', id);
        formData.append('trailer_no', trailer_no);
        if (!formData) {
            alert("Error uploading file");
            return;
        }
        try {
            const response = await fetch(`${URL_PREFIX}${uploadApi}`, {
                method: "POST",
                headers: {
                    // 'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${token}`,
                },
                body: formData,
            });
            const { data } = await response.json();
            if (response.status === 200) {
                setTrailers((prev: any) => prev.map((trailer: any) => trailer.id === data.id ? data : trailer));
            }
            if (response.status !== 200) {
                alert("Error uploading file");
                return;
            }
            alert("File uploaded successfully");
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <div>
            <input
                type="file"
                multiple
                accept={accept}
                style={{ display: 'none' }}
                id={`file-upload-${id}`}
                onChange={(e) =>
                    handleUploadFile(e.target.files ? Array.from(e.target.files) : null)
                }
            />

            <label htmlFor={`file-upload-${id}`}>
                <IconButton size="small" component="span">
                    <IconUpload size={16} />
                </IconButton>
            </label>
        </div>
    );
};


export default FileUpload;